import { notification } from 'antd';
class ToastActionsClass {
    createToast(message, description, toastType) {
        notification[toastType]({
            message,
            description,
        });
    }
    createToastError(message, description) {
        this.createToast(message, description, 'error');
    }
    createToastSuccess(message, description) {
        this.createToast(message, description, 'success');
    }
}
export const ToastActions = new ToastActionsClass();
//# sourceMappingURL=ToastActions.js.map